import firebase from 'firebase';
import { useState, useEffect } from 'react';
import "firebase/storage"

const config = {
    apiKey: "AIzaSyD4ovafxAthhu1I9-oVNujeauraPehi5FM",
    authDomain: "zaalday-project.firebaseapp.com",
    projectId: "zaalday-project",
    storageBucket: "zaalday-project.appspot.com",
    messagingSenderId: "1074381982408",
    appId: "1:1074381982408:web:d9980cabac0674c1c4f3fd",
    measurementId: "G-TC3BD1CJ7Z"
};

export const useFirebase = () => {
    const [state, setState] = useState({ firebase });

    useEffect(() => {
        let app;
        if (!firebase.apps.length) {
            firebase.initializeApp(config);
        }
        let auth = firebase.auth(app);
        let firestore = firebase.firestore(app);
        let storage = firebase.storage(app);
        let database = firebase.database(app)

        setState({ firebase, firestore, app, auth, storage, database })

    }, []);

    return state;
}

export const useDoc = (path) => {
    const { firestore } = useFirebase();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!firestore) {
            return;
        }
        firestore.doc(path).onSnapshot((doc) => {
            setData({ id: doc.id, ...doc.data() });
            setLoading(false);
        })

    }, [firestore, path])

    const updateRecord = (data) => {
        return firestore.doc(path).set(
            { ...data }, { merge: true }
        )
    }

    const deleteRecord = (path) => {
        return firestore.doc(path).delete();
    }

    const readAgain = () => {
        firestore.doc(path).get().then(function (doc) {
            setData(doc.data())
        }).catch(function (error) {
            console.log("Error getting cached document:", error);
        });
    }

    return { data, loading, updateRecord, deleteRecord, readAgain }
}

export const useCol = (path, sort = false) => {

    const { firestore } = useFirebase();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (firestore && path) {
            let query = firestore.collection(path);
            let order = sort ? query.orderBy('createdAt', 'asc') : query;

            const unsubscribe = order.onSnapshot((querySnapshot) => {
                setData(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
                setLoading(false);
            })

            return () => unsubscribe();
        }
    }, [firestore, path, sort])

    const updateRecord = (id, data) => {
        console.log(path, id);
        if (firestore)
            return firestore.collection(path).doc(id).set(
                {
                    ...data,
                    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
                },
                {
                    merge: true
                },
            )
        else
            return null
    }

    const createRecord = async (id, data) => {
        if (id === '') {
            const { id } = await firestore.collection(`${path}`).add(
                {
                    ...data,
                    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                }
            )

            return id;
        }
        return await firestore.collection(path).doc(id).set(
            {
                ...data,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            },
            {
                merge: true
            },
        )
    }

    const deleteRecord = async (id) => {
        return await firestore.collection(path).doc(id).delete();
    }

    return { data, loading, updateRecord, deleteRecord, createRecord }
}